export default "__VITE_ASSET__65e28f5b__"